// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2CQBY","title":"ClientReferral_title__I2sL-","itemText":"ClientReferral_itemText__ldPp-"};